<app-modal-header title="Edit Notable Activity"></app-modal-header>
<ion-content class="time-modal-content">
  <app-notable-activity
    *ngIf="notableActivityFormControlParams"
    [userId]="userId"
    [interval]="INTERVAL"
    [timeZoneId]="timeZoneId"
    [notableActivityFormControlParams]="notableActivityFormControlParams"
    (formValuesChanged)="onFormValuesChanged($event)"
  ></app-notable-activity>
  <app-footer-buttons-spacer></app-footer-buttons-spacer>
</ion-content>
<app-footer-buttons *ngIf="formValues"
  [rightButton]="{
    text: 'Save',
    disabled: !formValues.isValid
  }"
  [leftButton]="{
    icon: 'trash-outline',
    sizing: 'compact'
  }"
  (rightButtonClicked)="onSave()"
  (leftButtonClicked)="onDelete()"
></app-footer-buttons>
